import { IPoint2d } from '@/editor/math/IPoint2d';
import RBush, { BBox } from 'rbush';
import { arcThresholdValue } from '@/editor/math/const';

export interface RTreeNode<T = undefined> extends BBox {
  id: string | number;
  point: IPoint2d;
  infos: T[];
}

export class RTree<InfoType = null> {
  private _tolerance: number = arcThresholdValue;
  private _pointTree: RBush<RTreeNode<InfoType>>;

  constructor() {
    this._pointTree = new RBush();
  }

  addPoint(point: IPoint2d, info?: InfoType | null) {
    let nearNode = this.searchNearNode(point);
    if (!nearNode) {
      const node: RTreeNode<InfoType> = {
        id: '',
        minX: point.x - this._tolerance,
        minY: point.y - this._tolerance,
        maxX: point.x + this._tolerance,
        maxY: point.y + this._tolerance,
        point: point,
        infos: info ? [info] : []
      };
      this._pointTree.insert(node);
      nearNode = node;
    } else if (info) {
      nearNode.infos.push(info);
    }

    return nearNode;
  }

  searchNearNode(point: IPoint2d): RTreeNode<InfoType> | null {
    const node = {
      minX: point.x,
      minY: point.y,
      maxX: point.x,
      maxY: point.y
    };

    return this._pointTree.search(node)[0] || null;
  }

  searchNearPoint(point: IPoint2d): IPoint2d | null {
    const node = this.searchNearNode(point);

    return node ? node.point : null;
  }

  clear() {
    this._pointTree.clear();
  }
}
